import { TableKey } from '../types';

export const TABLE_ID = '1tNd1CwNf8abb13pI9oQXkZ8qbPMX64C9';
export const CACHE_KEY = 'configurator-data';
export const CACHE_TIME = 1000 * 60 * 60 * 24; // 24 hours
export const CACHE_VERSION = 'v0.0.1';
export const ZINC_DECK_LABEL = 'оцинкований';
export const RAL_DECK_LABEL = 'пофарбований';
export const TABLE_KEYS: Record<string, TableKey> = {
	['Висота']: TableKey.HEIGHT,
	['Ширина']: TableKey.WIDTH,
	['Глибина']: TableKey.DEPTH,
	['Ціна']: TableKey.PRICE,
	['Покриття каркасу']: TableKey.RACK,
	['Найменування']: TableKey.DECK,
};
